<template>
  <div id="root">

    <NavigaVue :datum="datum"></NavigaVue>
    <div class="row su-cerceve" >
      <div class="col">
        <CompanyId
          :datum="datum"
          :revsiteid="$route.params.revsiteid"
          :companyalias="$route.params.companyalias"
        ></CompanyId>
       
      </div>
      <div class="col">
        <TopicsRev
          :revsite="$route.params.revsiteid"
          :company="$route.params.dataid"
        ></TopicsRev>
      </div>
    </div>

    <ScoreCards :datum="datum"></ScoreCards>

    <div class="row">
      <div class="col">
        <FilterKeywords :datum="datum" title="Keyword Look-up" id="KeywordLookup"></FilterKeywords>

        <FreqKeywords :datum="datum" title="Ngrams Look-up" id="FreqKeywords"></FreqKeywords>
        <EnGrams :datum="datum" id="Ngrams"></EnGrams>
      </div>
      <div class="col">
        <BubbleChart 
          id = "KeywordProfiler"
          title="Keyword Profiler"
          desc="Bubble sizes by positive sentiment scores"
          :data="datum.wf"
          active_metric="positive_perc"
          bgColor="#047486"
        />

        <BubbleChart
          title="Keyword Profiler"
          desc="Bubble sizes by negative sentiment scores"
          :data="datum.wf"
          active_metric="negative_perc"
          bgColor="#da074d"
        />

        <TrendChart id="TrendChart" :datum="datum" title="Sentiment by time" desc="See trends of reviews" ></TrendChart>

      </div>
    </div>

    <!-- <EditorPicksHolder
      :companyalias="$route.params.companyalias"
      
    ></EditorPicksHolder> -->

    <div id="qa" v-if="datum.desc.qa">
      <!--Eger qa true denmisse buraya soru sorma paneli gelir-->
      <QuestionAnswering id="QuestionAnswering"
        :company_data_name="datum.desc.company"
      ></QuestionAnswering>
    </div>

    <ReviewsPanel
      scroll="false"
      :datum="datum"
      :datum_pos_df="datum_pos_df"
      :datum_neg_df="datum_neg_df"
      id="ReviewsPanel"
    ></ReviewsPanel>
  </div>
</template>
<script>
import "bootstrap-icons/font/bootstrap-icons.css";

// import AverageComparison from "@/components/AverageComparison.vue";
// import EditorPicksHolder from "@/components/EditorPicksHolder.vue";
import QuestionAnswering from "./QuestionAnswering.vue";
import TopicsRev from "@/components/TopicsRev.vue";
import ScoreCards from "@/components/ScoreCards.vue";
import BubbleChart from "@/components/BubbleChart.vue";
import CompanyId from "@/components/CompanyId.vue";
import FreqKeywords from "@/components/FreqKeywords.vue";
import EnGrams from "@/components/EnGrams.vue";
import ReviewsPanel from "@/components/ReviewsPanel.vue";
import FilterKeywords from "@/components/FilterKeywords.vue";
import TrendChart from "@/components/TrendChart.vue";
import NavigaVue from "@/components/NavigaVue.vue";


var _ = require("lodash");

export default {
  data() {
    return {
      company: "Endurance",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzOkXXJaly5BL33yHRI7bpVPq3_wwkSHh-v_UnlGoRl211ezYALGP2GhUf5_yDEBiRFg&usqp=CAU",
      intro: "Review Sentiment Analysis of the Endurance",
      datum: null,
      datum_pos_df: null,
      datum_neg_df: null,
    };
  },

  methods: {
    loaddata() {
      this.datum = require(`@/assets/analytics/${this.$route.params.revsiteid}/${this.$route.params.dataid}_dump.json`);
      (this.datum_pos_df = _.filter(this.datum.df, function (o) {
        return o.sentlabel == "POSITIVE";
      })),
        (this.datum_neg_df = _.filter(this.datum.df, function (o) {
          return o.sentlabel == "NEGATIVE";
        }));
    },
  },
  components: {
    // EditorPicksHolder,
    QuestionAnswering,
    TopicsRev,
    BubbleChart,
    ScoreCards,
    CompanyId,
    FreqKeywords,
    EnGrams,
    ReviewsPanel,
    FilterKeywords,
    TrendChart,
    NavigaVue
  },
  created() {
    this.loaddata();
  },
};
</script>

<style></style>
